// extracted by mini-css-extract-plugin
export default {"root":"Spinner_root__1UU8J","loader":"Spinner_loader__GbsJ1","animate":"Spinner_animate__Is3sY","spinner":"Spinner_spinner__H2HDD"};